module.exports = __webpack_public_path__ + "static/planwell_white-d5fdd712e0a8a2d1070c59cae588814a.svg";